// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/botbuilder/botmessages/index.scss
// module id = 3170
// module chunks = 13